import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import BreadCrum from '../basic/BreadCrum';
import './blog.css';

import { HeadingTitle } from '../basic/title';
import { AllCategories, LatestPosts } from '../basic/MultiUses';
import populartagsdata from '../../../data/populartagsdata';
import { Squarebtn } from '../basic/button';
import PaginationBlog from './PaginationBlog';

import { getBlog } from '../../../redux/slices/blog';

const BlogPage = ({
    allCategoriesData,
    categoryIsLoading,
    categoryError,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [selectedTag, setSelectedTag] = useState("All");

    const { allblog, isLoading: blogIsLoading, error: blogError } = useSelector(state => state.blog); // ✅ get blog from Redux

    // 👉 Fetch blogs on page load
    useEffect(() => {
        dispatch(getBlog());
    }, [dispatch]);

    // Just a visual delay for shimmer/loading (optional)
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const categoriDetailsRow = (id) => {
        navigate(`/categories/${id}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleTagFilter = (tag) => {
        setSelectedTag(tag);
        // Pass to PaginationBlog if tag-based filtering is implemented
    };

    return (
        <>
            <BreadCrum componentName="Blog" link="/blog" />
            <div className="container mx-auto max-w-7xl px-4 py-10">

                <div className="grid grid-cols-12 gap-8">
                    {/* Blog List */}
                    <div className='md:col-span-8 lg:col-span-9 col-span-12'>
                        <div data-aos="fade-up" data-aos-delay="200">
                            <PaginationBlog selectedTag={selectedTag} allblog={allblog} isLoading={blogIsLoading} />
                        </div>
                    </div>

                    {/* Sidebar */}
                    <div className='md:col-span-4 lg:col-span-3 col-span-12 space-y-10'>
                        {/* Categories */}
                        <div>
                            <HeadingTitle title="Categories" textAlign='left' />
                            {categoryIsLoading || loading ? (
                                allCategoriesData.map((_, index) => (
                                    <div key={index} className='animate-pulse mt-2 flex justify-between py-2'>
                                        <div className='w-[150px] py-2 bg-gray-300 rounded'></div>
                                        <div className='w-10 bg-gray-300 rounded'></div>
                                    </div>
                                ))
                            ) : categoryError ? (
                                <p className="text-red-600 font-medium">Error loading categories</p>
                            ) : (
                                <ul className="divide-y divide-gray-200">
                                    {allCategoriesData.map((row, index) => (
                                        <li
                                            key={index}
                                            className="py-2 cursor-pointer hover:text-[#036642]"
                                            onClick={() => categoriDetailsRow(row.id)}
                                        >
                                            {row.icon || '🛒'} {row.name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        {/* Latest Posts */}
                        <div>
                            <HeadingTitle title="Latest Posts" textAlign='left' />
                            <div className="bg-white rounded-xl shadow p-4">
                                <LatestPosts allblog={allblog?.slice(0, 3)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogPage;
